import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--dispatch-event"
// DOM接続時に指定されたカスタムイベントをdocumentに発火し、自身を削除する
export default class extends Controller {
  static values = { name: String };

  connect() {
    document.dispatchEvent(new CustomEvent(this.nameValue));
    this.element.remove();
  }
}
